export default {"src":"/_next/static/media/python.48573057.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};